import React from 'react'
import './style.css'
import Themetoggle from '../components/themetoggle'

const Headermain = () => {
  return (
    <>
      <header className='fixed-top site__header'>
        <div className='d-flex flex-row-reverse'>
          <Themetoggle />
        </div>
      </header>
      <div className='br-top'></div>
      <div className='br-bottom'></div>
      <div className='br-left'></div>
      <div className='br-right'></div>
    </>
  )
}

export default Headermain
